import { render, staticRenderFns } from "./ExperiencesSection.vue?vue&type=template&id=09dd47b0&"
import script from "./ExperiencesSection.vue?vue&type=script&lang=js&"
export * from "./ExperiencesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports